import { defineFetch } from 'resift';
import { WidgetLayoutCreateOrUpdateRequest } from 'pages/Homepage/typings';

const makeUpdateWidgetLayout = defineFetch({
  displayName: 'Update Widget Layout',
  share: {
    namespace: 'widget layout',
  },
  make: (widgetLayoutId: string) => ({
    request: (data: WidgetLayoutCreateOrUpdateRequest) => ({ http }) =>
      http({
        method: 'PUT',
        route: `/homepage-layouts/${widgetLayoutId}`,
        data,
      }),
  }),
});

export default makeUpdateWidgetLayout;
